import axios from "axios";

export default {
  namespaced: true,

  state: {
    niveles: null,
    pagination: {},
    incidents: null,
    dealerWait: null,
    qualification: null
  },

  getters: {
    getDealerWait: state => state.dealerWait,
    getIncidents: state => state.incidents,
    getQualification: state => state.qualification
  },

  mutations: {
    SET_QUALIFICATION(state, data) {
      state.qualification = data;
    },
    SET_INCIDENTS(state, data) {
      state.incidents = data;
    },
    SET_DEALER_WAIT(state, data) {
      state.dealerWait = data;
    },
    SET_NIVELES(state, data) {
      state.niveles = data;
    },
    SET_PAGINATION(state, data) {
      state.pagination = data;
    }
  },

  actions: {
    async GET_NIVELES(context, data) {
      try {
        const endpoint = process.env.VUE_APP_API_CATERINGV2;
        const  response = await axios.get( `${endpoint}/catering/levels?page=` + data.page,{
          params: data
        })
        const levels = response.data.detail
        context.commit('SET_NIVELES', levels.levels)
        context.commit('SET_PAGINATION', {
          page: levels.page,
          first_page_url: null,
          from: levels.from,
          last_page: levels.lastPage,
          last_page_url: null,
          next_page_url: null,
          path: null,
          rowsPerPage: levels.perPage,
          prev_page_url: null,
          to: levels.to,
          totalItems: levels.total,
        })
      }catch (e) {
        console.log(e)
      }
    },
    async GET_DEALER_WAIT(context, data) {
      try {
        const endpoint = process.env.VUE_APP_API_CATERINGV2;
        const  response = await axios.get( `${endpoint}/dealer-wait-details`,{
          params: data
        })
        context.commit('SET_DEALER_WAIT', response.data.detail)
      }catch (e) {
        console.log(e)
      }
    },
    async GET_INCIDENTS(context, data) {
      try {
        const endpoint = process.env.VUE_APP_API_CATERINGV2;
        const  response = await axios.get( `${endpoint}/customer-claims-details`,{
          params: data
        })
        context.commit('SET_INCIDENTS', response.data.detail)
      }catch (e) {
        console.log(e)
      }
    },
    async GET_QUALIFICATION(context, data) {
      try {
        const endpoint = process.env.VUE_APP_API_CATERINGV2;
        const  response = await axios.get( `${endpoint}/customer-qualifications-details`,{
          params: data
        })
        context.commit('SET_QUALIFICATION', response.data.detail)
      }catch (e) {
        console.log(e)
      }
    }
  }
};
